import React from "react";
import "./mc.css";
import ConnectWithUs from "../../common_components/ConnectWithUs";
import Header from "../../common_components/Header";
import Footer from "../../common_components/Footer";
import log1 from "../../assets/img/log1.jpg"
function Atf() {
  return (
    <React.Fragment>
        <Header></Header>
        <h3>Follow these steps to apply for Academic Transcript Form</h3>

     <div className="container atf">
        <div className="left-part">
            <img src={log1} alt="" className="img-fluid"/>
        </div>
        <div className="right-part">
            <ul>
                <li><i className="fas fa-chevron-circle-right"></i>
                    Go to <a href="https://vtop.vitap.ac.in">VTOP</a>(supported by Chrome and Firefox)</li>
                <li><i className="fas fa-chevron-circle-right"></i>
                    Click Alumni Login</li>
                <li><i className="fas fa-chevron-circle-right"></i>
                    Login using your Credentials (a) Registration Number (b) VIT Alumni Email ID and (c) Date of Birth</li>
                <li><i className="fas fa-chevron-circle-right"></i>
                    If you don’t know your Alumni Email ID, you can update any of your emails by writing to 
                    <a href="‘helpdesk.coe@vit.ac.in’.">Help Desk</a> 
                    To prove your identity, you are required to attach a scanned copy of any one of the following documents: grade cards / provisional / degree.</li>
                <li><i className="fas fa-chevron-circle-right"></i>
                    After receiving the confirmation mail from helpdesk, login to VTop. Fill the required details and make necessary payments.</li>
                <li><i className="fas fa-chevron-circle-right"></i>
                    For clarifications / queries contact: helpdesk.coe@vit.ac.in (or) 91-416 220 2851.</li>
                <li><i className="fas fa-chevron-circle-right"></i>
                    The existing offline process is herewith discontinued.</li>
            </ul>
        </div>
    </div>
    <ConnectWithUs></ConnectWithUs>
      <Footer></Footer>
    </React.Fragment>
  );
}
export default Atf;
